import { colorsTypes } from "../constantes/actionTypes"

const initialState = []

export const colors = (state = initialState, action) => {
    switch (action.type) {
        case colorsTypes.GET_ALL_COLORS_SUCCESS:
            return action.payload
        case colorsTypes.GET_ALL_COLORS_FAILURE:
            return initialState
        default:
            return state
    }
}